<script>
import Theme from '@/theme'
import LocalStorage from '@/utils/localStorageUtils'

export default
{
    name: 'theme',

    render () 
    {
        const themePreview = (name, theme) => (
            <div class={`theme-preview-box ${Theme.current.name == theme.name ? 'selected' : ''} ${theme.name}`}
                on-click={() => this.onThemePreviewClicked(theme)}>
                <div class='theme-name' style={{ backgroundColor: theme.accentColor }}>
                    <span class='text'>{ name }</span>
                </div>
                <div class='elements-preview' style={{ backgroundColor: theme.backgroundColor || Theme.themes.default.backgroundColor}}>
                    <div class='checked-icon'>
                        <inline-svg src={require('@/assets/img/check.svg')} />
                    </div>
                </div>
            </div>
        )

        return (
            <div id='theme-view'>
                <span class='section-title'>Choisir un thème</span>
                <p class='section-description'>Selectionnez un thème qui vous correspond pour personnaliser votre expérience.</p>
                <div class='themes-preview'>
                { themePreview('Myrtille', Theme.themes.blueberry) }
                { themePreview('Crépuscule', Theme.themes.twilight) }
                </div>
                { themePreview('Automatique', Theme.themes.auto) }
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    methods:
    {
        onThemePreviewClicked (theme)
        {
            Theme.current = theme

            console.log('Selecting theme', theme.name)

            LocalStorage.activeTheme = theme.name
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#theme-view
{
    padding: 14px 1px 16px 1px;

    .section-title
    {
        font-weight: 500;
        font-size: 5vw;
        .OnTablet({ font-size: 3.5vw; });
        .OnDesktop({ font-size: 1.7vw; });
        .OnLarge({ font-size: 1.2vw; });
    }

    .section-description
    {
        margin-top: 10px;
        color: var(--theme-text-color-light);
        font-size: 4vw;

        .OnTablet({ font-size: 2.5vw; });
        .OnDesktop({ font-size: 1vw; });
        .OnLarge({ font-size: 0.8vw; });
    }

    .themes-preview
    {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 0 -10px;

        .theme-preview-box
        {
            margin-top: 5vh;
            margin-left: 10px;
            margin-right: 10px;
        }
    }

    .theme-preview-box
    {
        @border-radius: 5px;

        display: flex;
        flex-direction: column;
        width: 100%;
        cursor: pointer;

        &.selected
        {
            .elements-preview .checked-icon svg
            {
                fill: var(--theme-background-text-color);
            }
        }

        &.auto
        {
            margin-top: 20px;

            .theme-name
            {
                background: linear-gradient(45deg, #684FA3 44%, #5C64EE 44%);
            }

            .elements-preview
            {
                background: linear-gradient(45deg, rgb(40, 40, 40) 60%, #F2F3F7 60%);
            }
        }

        .theme-name
        {
            border-radius: @border-radius @border-radius 0 0;
            font-family: Nunito;
            color: white;
            width: 100%;
            display: flex;
            align-items: center;
            font-size: 90%;
            height: 8vw;

            .OnTablet({
                font-size: 3vw;
                height: 8vw;
            });

            .OnDesktop({
                font-size: 1.2vw;
                height: 4vw;
            });

            .OnLarge({
                font-size: 1vw;
                height: 3vw;
            });

            .text
            {
                margin-left: 5vw;

                .OnTablet({ margin-left: 3vw; });
                .OnDesktop({ margin-left: 2vw; });
            }
        }

        .elements-preview
        {
            border-radius: 0 0 @border-radius @border-radius;
            width: 100%;
            min-height: 25vw;
            display: flex;
            justify-content: center;
            align-items: center;

            .OnTablet({ min-height: 17vw; });
            .OnDesktop({ min-height: 10vw; });
            .OnLarge({ min-height: 8vw; });

            .checked-icon
            {
                svg
                {
                    fill: transparent;
                    width: 10vw;

                    .OnTablet({ width: 6vw; });
                    .OnDesktop({ width: 3vw; });
                    .OnLarge({ width: 2.5vw; });
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Theme.vue